module.exports = __webpack_public_path__ + "img/GROUP_BY_TABLE.8fd0784a.svg";